import type { Library } from '../db/schema'

/**
 * 由來源 handle 與作品的相對路徑取得該作品的資料夾。
 * relPath 為空字串代表「這個來源本身就是一本作品」（kind 為 comic），直接回傳來源 handle。
 * 其他地方一律呼叫這個函式，不要自行判斷 relPath 是否為空。
 */
export async function resolveComicDirectory(
  root: FileSystemDirectoryHandle,
  relPath: string,
): Promise<FileSystemDirectoryHandle> {
  let directory = root
  for (const segment of relPath.split('/').filter(Boolean)) {
    directory = await directory.getDirectoryHandle(segment)
  }
  return directory
}

/** 取得壓縮檔作品的檔案。relPath 的最末段是檔名，前面各段是資料夾。 */
export async function resolveComicArchive(
  root: FileSystemDirectoryHandle,
  relPath: string,
): Promise<File> {
  const segments = relPath.split('/').filter(Boolean)
  const name = segments.pop()
  if (!name) throw new Error('壓縮檔作品缺少檔名')
  let directory = root
  for (const segment of segments) directory = await directory.getDirectoryHandle(segment)
  return (await directory.getFileHandle(name)).getFile()
}

/** 找出作品所屬的來源；來源不存在（資料被清掉）時回傳 undefined。 */
export function libraryForComic(
  libraries: readonly Library[],
  libraryId: string,
): Library | undefined {
  return libraries.find(library => library.id === libraryId)
}

/** 選到的資料夾是否已經是某個來源。以 FileSystemHandle 的同一性判斷，不用名稱。 */
export async function findSameSource(
  libraries: readonly Library[],
  handle: FileSystemDirectoryHandle,
): Promise<Library | undefined> {
  for (const library of libraries) {
    try {
      if (await library.handle.isSameEntry(handle)) return library
    } catch { /* handle 已失效的來源不參與比對。 */ }
  }
  return undefined
}
